import React from 'react'
import propTypes from 'prop-types'
import { createPortal } from 'react-dom'
import classNames from 'classnames'
import { Transition } from '@headlessui/react'
import { FaTimes } from 'react-icons/fa'


export default function Modal(props) {
  const [_fullscreen, setFullscreen] = React.useState(false)

  const fullscreen = props.fullscreen

  React.useEffect(() => {
    setFullscreen(fullscreen)
  }, [fullscreen])

  const active = props.active
  React.useEffect(() => {
    if (active)
      document.querySelector('body').classList.add('overflow-hidden')
    else
      document.querySelector('body').classList.remove('overflow-hidden')

    return () => {
      document.querySelector('body').classList.remove('overflow-hidden')
    }
  }, [active])

  const modalContent = createPortal(
    <Transition
      as={React.Fragment}
      show={props.active}
      enter='transition duration-3000 ease-out'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='transition duration-3000 ease-out'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'
    >
      <div
        onClick={props.onClose}
        className={classNames([
          'z-50 flex fixed left-0 right-0 top-0 bottom-0 overflow-auto p-2 sm:p-10 transform',
          'bg-black bg-opacity-80',
          props.containerClassName,
        ])}
      >
        <div
          onClick={props.onClose}
          className={classNames(
            'fixed text-2xl right-0 top-0 z-30',
            'transition-all',
            'shadow-lg lg:shadow-none',
            'cursor-pointer',
            'bg-white lg:bg-opacity-0 rounded-bl-xl p-2',
            'text-disabled-700 lg:text-white hover:text-primary-600',
            {'top-0 right-0': _fullscreen},
            {'lg:right-10 lg:top-10': ! _fullscreen},
          )}
        >
          <FaTimes />
        </div>
        <div
          className={classNames([
            'bg-white transition-all m-auto relative',
            {
              'w-full max-w-full h-full rounded-none overflow-auto': _fullscreen,
              'max-w-screen-sm w-full rounded-lg': ! _fullscreen,
            },
            props.className,
          ])}
          onClick={e => {
            e.stopPropagation()
          }}
        >
          {props.children}
        </div>
      </div>
    </Transition>,
    document.querySelector('body')
  )
  return modalContent
}

Modal.propTypes = {
  containerClassName: propTypes.string,
  className: propTypes.string,
  children: propTypes.oneOfType([
    propTypes.shape({
      type: propTypes.oneOf([Action, Content]),
    }),
    propTypes.arrayOf(
      propTypes.shape({
        type: propTypes.oneOf([Action, Content]),
      })
    ),
  ]).isRequired,
  onClose: propTypes.func,
  onOpen: propTypes.func,
  active: propTypes.bool,
}


export function Action(props) {
  return (
    <div className={classNames([
      'self-end flex-grow-0',
      props.className,
    ])}>
      {props.children}
    </div>
  )
}

Action.propTypes = {
  className: propTypes.string,
}


export function Content(props) {
  return (
    <div className={classNames([
      'flex-grow p-5 sm:p-10',
      props.className,
    ])}>
      {props.children}
    </div>
  )
}

Content.propTypes = {
  className: propTypes.string,
}


Modal.Content = Content
Modal.Action = Action
